import React, {useEffect, useState} from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {CF} from 'module/CustomField/util/CustomField'
import {log} from 'common/log'
import {getSisDurationAsISO, getSisDurationBetween24H, parseSisTime} from 'util/SisDateTime'
import {SisType} from 'generated/JavaTO'
import {stripHTML} from 'util/StringUtil'
import {cssCFInput} from 'module/CustomField/component/input/style/cssCFInput'

function toDuration(timeFrom: number, endTime: string) {
	const from = parseSisTime(timeFrom, {ignoreSeconds: true})
	const to = parseSisTime(endTime, {userInput: true, ignoreSeconds: true})
	return getSisDurationAsISO(getSisDurationBetween24H(from, to))
}


export function CustomFieldDurationAsTimeToComponent(props: CFComponentProps<string>) {
	let {model, modelValue, cfDef, setCb, disabled, placeholderHTML} = props
	if (!modelValue) modelValue = ''
	const attrFrom = CF.getCFAttr(cfDef, CFAttrKey.TimeFromAttr)?.value
	const [viewValue, setViewValue] = useState(modelValue)
	useEffect(() => setViewValue(modelValue), [modelValue])
	if (!attrFrom) {
		log.error('Missing CFAttrKey: TimeFromAttr')
		return <div>ERROR: missing TimeFromAttr</div>
	} else if (cfDef.type !== SisType.Duration) {
		log.error('wrong cfDef.type (H required)', cfDef)
		return <div>ERROR: wrong type</div>
	}
	return <div>
		<input
			disabled={disabled}
			css={cssCFInput}
			placeholder={stripHTML(placeholderHTML)}
			onChange={evt => setViewValue(evt.target.value)}
			value={viewValue}
			onFocus={(evt) => evt.target.select()}
			onBlur={() => {
				setViewValue(modelValue) // when no change happened, this value is kept in input. Otherwise the set call initiates the useEffect
				setCb(toDuration(model[attrFrom as string], viewValue))
			}}
		/>
	</div>
}